import type { AxiosError } from 'axios';
class CreateWorkspaceError {
  flag: boolean;
  message: string;

  constructor(private error: AxiosError) {
    this.flag = false;
    this.message = '';
  }

  handle() {
    if (this.error.response?.status === 409) {
      this.flag = true;
      this.message = 'The workspace name is already in use.';
    }
    return { flag: true, message: 'Unknown Error' };
  }
}

export default CreateWorkspaceError;
